import React, { useState } from "react";
import { Zap, ChevronDown } from "lucide-react";

const ImmediateActions = ({ actions }) => {
  const [open, setOpen] = useState(true);
  if (!actions || actions.length === 0) return null;
  return (
    <div className="rounded-2xl bg-white border border-slate-200 shadow-[0_1px_2px_rgba(15,23,42,0.04),0_10px_30px_-24px_rgba(15,23,42,0.22)] shadow-xl h-full overflow-hidden" data-testid="immediate-actions-container">
      <button onClick={() => setOpen((o) => !o)} className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-slate-100 transition-colors" data-testid="immediate-actions-toggle">
        <h3 className="text-lg font-bold text-slate-900">{actions.length} Immediate Actions</h3>
        <ChevronDown className={`w-4 h-4 text-slate-500 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <ol className="px-5 pb-5 space-y-2.5">
          {actions.map((a, i) => (
            <li key={i} className="accent-bar rounded-xl border border-slate-200 bg-slate-50 p-3 pl-4" style={{ "--accent": "#D97706" }} data-testid={`immediate-action-${i}`}>
              <p className="inline-flex items-center gap-1.5 text-[10px] font-mono uppercase tracking-wider text-amber-700">
                <Zap className="w-3 h-3" /> Action {i + 1}
              </p>
              <p className="mt-1 text-sm text-slate-800">{a}</p>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
};

export default ImmediateActions;
